import axios from "axios";
import { API_BASE_URL, API_BASE_URL1 } from "../Services/baseApiUrl";
//const countryId =localStorage.getItem("country_Id");
import { toast } from "react-toastify";
import axiosInstance from "../../Hooks/axoisInstance";

const getToken = () => {
  return localStorage.getItem("token");
};

export const AllShiftMaster = async () => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `MasterDetails/GetAllShifts`, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;

  }
};

export const AddShiftName = async (shiftData) => {
  try {
    const response = await axiosInstance.post(
      API_BASE_URL1 + `MasterCreate/AddNewShift`,
      shiftData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    // Show success message if request is successful
    // const successMessage = "Shift Details Added Successfully";
    // toast.success(successMessage, {
    //   position: "top-right",
    //   autoClose: 3000,
    //   hideProgressBar: false,
    //   closeOnClick: true,
    //   pauseOnHover: true,
    //   draggable: true,
    //   progress: undefined,
    // });

    return response;
  } catch (error) {
    // Handle the error here
    // if (error.response && error.response.status === 422) {
    //   // Handle validation errors
    //   console.log(typeof error.response.data.errors);
    //   if (typeof error.response.data.errors === "object") {
    //     Object.values(error.response.data.errors).forEach((item) => {
    //       toast.error(item[0], {
    //         position: "top-right",
    //         autoClose: 3000,
    //         hideProgressBar: false,
    //         closeOnClick: true,
    //         pauseOnHover: true,
    //         draggable: true,
    //         progress: undefined,
    //       });
    //     });
    //   } else if (typeof error.response.data.errors === "string") {
    //     toast.error(error.response.data.errors, {
    //       position: "top-right",
    //       autoClose: 3000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //     });
    //   }
    // } else {
    //   // Show the error message in the toast
    //   toast.error(JSON.stringify(error), {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //   });
    // }
    throw error;

  }
};

export const UpdateShiftDetails = async (shiftData) => {
  try {
    const response = await axiosInstance.put(
      API_BASE_URL1 + `MasterCreate/UpdateShiftDetails`,
      shiftData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    // const successMessage = "Shift Details Updated Successfully";
    // toast.success(successMessage, {
    //   position: "top-right",
    //   autoClose: 3000,
    //   hideProgressBar: false,
    //   closeOnClick: true,
    //   pauseOnHover: true,
    //   draggable: true,
    //   progress: undefined,
    // });

    // if (!response.ok) {
    //   throw new Error("Failed to add Shift");
    // }

    return response;
  } catch (error) {

    // Handle the error here
    // if (error.response && error.response.status === 422) {
    //   // Handle validation errors
    //   console.log(typeof error.response.data.errors);
    //   if (typeof error.response.data.errors === "object") {
    //     Object.values(error.response.data.errors).forEach((item) => {
    //       toast.error(item[0], {
    //         position: "top-right",
    //         autoClose: 3000,
    //         hideProgressBar: false,
    //         closeOnClick: true,
    //         pauseOnHover: true,
    //         draggable: true,
    //         progress: undefined,
    //       });
    //     });
    //   } else if (typeof error.response.data.errors === "string") {
    //     toast.error(error.response.data.errors, {
    //       position: "top-right",
    //       autoClose: 3000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //     });
    //   }
    // }
    throw error;

  }
};

export const AddState = async (stateData) => {
  try {
    const response = await axiosInstance.post(
      API_BASE_URL1 + `state/create`,
      stateData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    return response;
  } catch (error) {
    // throw new Error("Error adding state: " + error.message);

  }
};

export const getShiftById = async (id) => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `shift/getById/${id}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        },

      });
    // console.log(response, 'response')
    return response;
  } catch (error) {
    throw error

  }
};
